var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appBorders } from '@backrs_ui/common-ui/src/assets/appBorders';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ReactComponent as OtpDecoration } from '@backrs_ui/common-ui/src/assets/images/otp-decoration.svg';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { Box, Typography } from '@mui/material';
import { BackrsForm } from '../BackrsForm/BackrsForm';
import { ResendCode } from '../BackrsForm/ResendCode';
var LOGIN_STRINGS = appStrings.modules.login;
var defaultOtpValues = {
    code: '',
};
export var OneTimePassword = function (_a) {
    var handleOtpCode = _a.handleOtpCode, errorMessage = _a.errorMessage, environmentUrl = _a.environmentUrl;
    var fields = [
        {
            id: 'code',
            name: 'code',
            placeholder: '######',
            type: 'tel',
            autoComplete: 'code',
            sx: otpInputStyle,
            inputProps: otpInputProps,
        },
    ];
    var handleSubmission = function (data) {
        handleOtpCode(data.code);
    };
    return (_jsxs(Box, { sx: containerStyle, children: [_jsx(BackrsIcon, { name: "BackrsWithText", alt: "backrs logo", style: responsiveBackrsLogoStyle }), _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Typography, { variant: "h4", sx: otpPromptStyle, children: LOGIN_STRINGS.otp.title }), _jsx(BackrsForm, { fields: fields, defaultValues: defaultOtpValues, onSubmit: handleSubmission, buttonLabel: appStrings.buttonText.login, children: _jsxs(Box, { sx: otpContentWrapperStyle, children: [_jsx(ResendCode, { environmentUrl: environmentUrl }), _jsx(Box, { sx: otpDecorationContainerStyle, children: _jsx(OtpDecoration, { width: "100%" }) })] }) }), errorMessage && (_jsx(Box, { mt: 2, color: appColors.color.red1, children: errorMessage }))] })] }));
};
var containerStyle = {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: 4,
};
var loginFormStyle = __assign({ backgroundColor: appColors.neutral.white, paddingX: 2, paddingY: 3, borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '100%', width: '100%', boxSizing: 'border-box', '@media (min-width: 300px)': {
        paddingX: 2,
        paddingY: 4,
    }, '@media (min-width: 600px)': {
        maxWidth: '500px',
        paddingX: 11,
        paddingY: 8,
    } }, appBorders.backrsDropShadowBorders.black);
var responsiveBackrsLogoStyle = {
    width: '100%',
    maxWidth: '175px',
    padding: '8px',
    marginBottom: '32px',
};
var otpPromptStyle = {
    maxWidth: '300px',
    color: appColors.color.navy3,
    fontSize: '1.5rem',
    fontWeight: 700,
    textAlign: 'center',
    mb: 3,
};
var otpContentWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
var otpDecorationContainerStyle = {
    width: '100%',
    maxWidth: '350px',
    padding: 1,
};
var otpInputStyle = {
    mb: 4,
};
var otpInputProps = {
    style: { textAlign: 'center', letterSpacing: '0.75rem', fontSize: '1.5rem' },
    maxLength: 6,
};
